<template>
    <div class="card mb-4" :class="[anyErrorsForAnyLang ? 'border-error' : 'border-normal']">
        <div class="card-header">
            <ul class="nav nav-tabs card-header-tabs" id="equipment">
                <li class="nav-item" v-for="lang in languages">
                    <a class="nav-link text-primary cursor-pointer"
                       :class="[language === lang ? 'active': '', anyErrorsForLang(lang) ? 'text-danger font-weight-bold' : 'text-primary']"
                       @click="language = lang; $emit('update:language', language)">
                        <i class="font-weight-bold mdi mdi-alert text-danger" v-if="anyErrorsForLang(lang)"></i>
                        {{ $t('lang.' + lang) }}
                    </a>
                </li>
            </ul>
        </div>
        <div class="card-body">
            <slot></slot>
        </div>
    </div>

</template>

<script>
export default {
    name: "LanguageSwitcherNav",
    props: {
        languages: {
            type: Array,
            default: () => ['en', 'de', 'lb']
        }
    },
    data: () => ({
        language: ''
    }),
    methods: {
        /**
         * Returns the languages that include errors in the global error bag.
         * Used to show an error icon.
         *
         * @param lang
         * @returns {boolean}
         */
        anyErrorsForLang(lang) {
            return this.languagesContainedInErrorBag.includes(lang);
        },
    },
    mounted() {
        if(this.language === '')
            this.language = this.languages[0];
    },
    computed: {
        errorBag() {
            return this.$errors.errors;
        },
        languagesContainedInErrorBag() {
            let objectKeys = Object.keys(this.errorBag); // Get the object keys
            let splitObjectKeys = objectKeys.flatMap(k => k.split('.')); // Split Objeyt keys (eg title.en => ['title', 'en']
            let uniqueSplitObjectKeys = [...new Set(splitObjectKeys)]; // Remove duplicates
            return uniqueSplitObjectKeys.filter((k => this.languages.includes(k))) // Remove everything that is not a language code - eg. ['title', 'en'] => ['en']
        },
        anyErrorsForAnyLang() {
            return this.languagesContainedInErrorBag.length > 0;
        }
    }
}
</script>

<style scoped>
    .border-normal {border: 1px solid #d9d9d9}
    .border-error {border: 1px solid red}
</style>
